import React, { useEffect, useState } from "react";
import image1 from "../../assets/carrusel/carrusel1.webp";
import image2 from "../../assets/carrusel/carrusel2.webp";
import image3 from "../../assets/carrusel/carrusel3.webp";

export default function Carousel() {
	const slides = [image1, image2, image3];
	const [currentIndex, setCurrentIndex] = useState(0);
	const interval = 5000;

	useEffect(() => {
		const timer = setInterval(() => {
			setCurrentIndex((prevIndex) =>
				prevIndex === slides.length - 1 ? 0 : prevIndex + 1
			);
		}, interval);

		return () => clearInterval(timer);
	}, [slides.length, interval]);

	return (
		<div className="relative w-full h-96 md:h-[50rem] overflow-hidden bg-black">
			{slides.map((slide, index) => (
				<img
					key={index}
					src={slide}
					alt={`slide-${index}`}
					className={`absolute top-0 left-0 w-full h-full object-cover transition-opacity duration-1000 ${
						index === currentIndex ? "opacity-100" : "opacity-0"
					}`}
				/>
			))}
			<div className="absolute inset-20 flex items-center">
				<div className="bg-black/50 text-white w-full md:w-2/5 p-5 md:p-10 rounded-r-lg backdrop-blur-sm">
					<h2 className="text-2xl md:text-4xl font-bold mb-3 uppercase">
						transportes ejecutivos
					</h2>
					<p className="text-sm md:text-lg leading-relaxed mb-5">
						Brindar el mejor servicio en la renta de autos para ejecutivos en
						México con nuestros vehículos en excelente estado, nos
						especializamos en el sector de negocios y servicio ejecutivo.
					</p>
					<button
						className="m-2 border-2 border-[#cbbca3] px-10 py-3 rounded-full font-bold text-[#cbbca3] uppercase"
						type="button"
					>
						empezar
					</button>
				</div>
			</div>
		</div>
	);
}
